import React, { createContext, useContext, useMemo, useState } from 'react';

interface IRulerContext {
    showRuler: boolean;
    toggleRuler: () => void;
}

const RulerContext = createContext<IRulerContext>({
    showRuler: false,
    toggleRuler: () => undefined,
});

export const RulerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [showRuler, setShowRuler] = useState(false);

    const toggleRuler = () => setShowRuler(prev => !prev);

    const contextValue = useMemo(() => ({ showRuler, toggleRuler }), [showRuler]);
    return <RulerContext.Provider value={contextValue}>{children}</RulerContext.Provider>;
};

export const useRuler = () => useContext(RulerContext);
